import {initParallaxSection} from "../components/parallax-section";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger.js";
import {isMobile, isTablet} from "../components/helpers";

export function initMigAppLanding() {
    if (!$('#migapp_landing').length) return;

    initParallaxSection();
    if (!isMobile()) {
        gsap.registerPlugin(ScrollTrigger);

        gsap
            .fromTo('.animated', {
                scrollTrigger: {
                    trigger: $('#first_trigger'),
                    scroller: isMobile() || isTablet() ? '' : '.scroller',
                    start: () => 'center bottom',
                },
                xPercent: 120
            }, {
                scrollTrigger: {
                    trigger: $('#first_trigger'),
                    scroller: isMobile() || isTablet() ? '' : '.scroller',
                    start: () => 'center bottom',
                },
                xPercent: 0
            });

        gsap
            .fromTo('.animated-2', {
                scrollTrigger: {
                    trigger: $('#second_trigger'),
                    scroller: isMobile() || isTablet() ? '' : '.scroller',
                    start: () => 'center bottom',
                },
                xPercent: -120
            }, {
                scrollTrigger: {
                    trigger: $('#second_trigger'),
                    scroller: isMobile() || isTablet() ? '' : '.scroller',
                    start: () => 'center bottom',
                },
                xPercent: 0
            });
    }

}
